export const usd = (v) => Number(v || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

const TONES = {
  complimentary: "bg-sky-50 text-sky-800 border-sky-200",
  active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  trialing: "bg-violet-50 text-violet-800 border-violet-200",
  past_due: "bg-red-50 text-red-800 border-red-200",
  archived: "bg-slate-200 text-slate-600 border-slate-300",
};
const LABELS = { archived: "Archived", complimentary: "Complimentary", active: "Paying", trialing: "Trial", past_due: "Overdue", canceled: "Cancelled", not_subscribed: "Not subscribed", incomplete: "Incomplete", unpaid: "Unpaid" };

export const statusKey = (b) => (b.archived ? "archived" : b.complimentary ? "complimentary" : b.status || "not_subscribed");

export const StatusPill = ({ billing, testid }) => {
  const k = statusKey(billing);
  return (
    <span className={`inline-block border px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider ${TONES[k] || "bg-slate-50 text-slate-600 border-slate-200"}`} data-testid={testid}>
      {LABELS[k] || k}
    </span>
  );
};
